import { updateObject } from '../../shared/utility';
import { GET_EMPLOYEES_START, GET_EMPLOYEES_SUCCESS, GET_EMPLOYEES_FAIL, CREATE_EMPLOYEE_START, CREATE_EMPLOYEE_SUCCESS, CREATE_EMPLOYEE_FAIL, CLEAR_DATA, UPDATE_EMPLOYEE_START, UPDATE_EMPLOYEE_SUCCESS, UPDATE_EMPLOYEE_FAIL, OPEN_EDIT_FORM, CLOSE_EDIT_FORM, CLEAR_EDIT } from '../actions/actionTypes';

const initialState = {
    error: null,
    message:null,
    loading: false,
    employees: [],
    editEmployee:{
        id:null,
        name:null,
        username:null,
        role:null
    },
    visibleEditForm:false,
}

const getEmployeesStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getEmployeesSuccess = (state, action) => {
    return updateObject(state, { error: null, loading: false, employees: action.employees });
}

const getEmployeesFail = (state, action) => {
    return updateObject(state, { error: action.error, loading: false, employees: [] });
}

const clearData = (state, action) => {
    return updateObject(state, { employees: action.employees });
}

const createEmployeeStart=(state, action)=>{
    return updateObject(state,{error:null, loading:true});
}

const createEmployeeSuccess=(state, action)=>{
    return updateObject(state,{error:null, message:action.message, loading:false});
}

const createEmployeeFail=(state, action)=>{
    return updateObject(state,{error:action.error,loading:false});
}

const openEditForm=(state,action)=>{
    return updateObject(state,{visibleEditForm:true,editEmployee:action.editEmployee});
}

const closeEditForm=(state,action)=>{
    return updateObject(state,{visibleEditForm:false});
}

const clearEdit=(state,action)=>{
    return updateObject(state,{error:null,message:null});
}

const updateUserStart=(state,action)=>{
    return updateObject(state,{error:null,message:null,loading:true});
}
const updateUserSuccess=(state,action)=>{
    return updateObject(state,{error:null,message:action.message,loading:false});
}
const updateUserFail=(state,action)=>{
    return updateObject(state,{error:action.error,message:null,loading:false});
}
const employeeReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMPLOYEES_START:
            return getEmployeesStart(state, action);
        case GET_EMPLOYEES_SUCCESS:
            return getEmployeesSuccess(state, action);
        case GET_EMPLOYEES_FAIL:
            return getEmployeesFail(state, action);
        case CLEAR_DATA:
            return clearData(state, action);
        case CREATE_EMPLOYEE_START:
            return createEmployeeStart(state,action);
        case CREATE_EMPLOYEE_SUCCESS:
            return createEmployeeSuccess(state,action);
        case CREATE_EMPLOYEE_FAIL:
            return createEmployeeFail(state,action);
        case UPDATE_EMPLOYEE_START:
            return updateUserStart(state,action);
        case UPDATE_EMPLOYEE_SUCCESS:
            return updateUserSuccess(state,action);
        case UPDATE_EMPLOYEE_FAIL:
            return updateUserFail(state,action);
        case OPEN_EDIT_FORM:
            return openEditForm(state,action);
        case CLOSE_EDIT_FORM:
            return closeEditForm(state,action);
        case CLEAR_EDIT:
            return clearEdit(state,action);
        default:
            return state;
    }

}

export default employeeReducer;